/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectItemCreateProjectItemPost } from '../fn/project-items/api-project-item-create-project-item-post';
import { ApiProjectItemCreateProjectItemPost$Params } from '../fn/project-items/api-project-item-create-project-item-post';
import { apiProjectItemCreateProjectItemPost$Plain } from '../fn/project-items/api-project-item-create-project-item-post-plain';
import { ApiProjectItemCreateProjectItemPost$Plain$Params } from '../fn/project-items/api-project-item-create-project-item-post-plain';
import { apiProjectItemDeleteProjectItemDelete } from '../fn/project-items/api-project-item-delete-project-item-delete';
import { ApiProjectItemDeleteProjectItemDelete$Params } from '../fn/project-items/api-project-item-delete-project-item-delete';
import { apiProjectItemDeleteProjectItemDelete$Plain } from '../fn/project-items/api-project-item-delete-project-item-delete-plain';
import { ApiProjectItemDeleteProjectItemDelete$Plain$Params } from '../fn/project-items/api-project-item-delete-project-item-delete-plain';
import { apiProjectItemDownloadTemplateGet } from '../fn/project-items/api-project-item-download-template-get';
import { ApiProjectItemDownloadTemplateGet$Params } from '../fn/project-items/api-project-item-download-template-get';
import { apiProjectItemGetProjectItemCostGet } from '../fn/project-items/api-project-item-get-project-item-cost-get';
import { ApiProjectItemGetProjectItemCostGet$Params } from '../fn/project-items/api-project-item-get-project-item-cost-get';
import { apiProjectItemGetProjectItemCostGet$Plain } from '../fn/project-items/api-project-item-get-project-item-cost-get-plain';
import { ApiProjectItemGetProjectItemCostGet$Plain$Params } from '../fn/project-items/api-project-item-get-project-item-cost-get-plain';
import { apiProjectItemGetProjectItemsCostGet } from '../fn/project-items/api-project-item-get-project-items-cost-get';
import { ApiProjectItemGetProjectItemsCostGet$Params } from '../fn/project-items/api-project-item-get-project-items-cost-get';
import { apiProjectItemGetProjectItemsCostGet$Plain } from '../fn/project-items/api-project-item-get-project-items-cost-get-plain';
import { ApiProjectItemGetProjectItemsCostGet$Plain$Params } from '../fn/project-items/api-project-item-get-project-items-cost-get-plain';
import { apiProjectItemGetProjectItemsNamesGet } from '../fn/project-items/api-project-item-get-project-items-names-get';
import { ApiProjectItemGetProjectItemsNamesGet$Params } from '../fn/project-items/api-project-item-get-project-items-names-get';
import { apiProjectItemGetProjectItemsNamesGet$Plain } from '../fn/project-items/api-project-item-get-project-items-names-get-plain';
import { ApiProjectItemGetProjectItemsNamesGet$Plain$Params } from '../fn/project-items/api-project-item-get-project-items-names-get-plain';
import { apiProjectItemGetProjectItemsPost } from '../fn/project-items/api-project-item-get-project-items-post';
import { ApiProjectItemGetProjectItemsPost$Params } from '../fn/project-items/api-project-item-get-project-items-post';
import { apiProjectItemGetProjectItemsPost$Plain } from '../fn/project-items/api-project-item-get-project-items-post-plain';
import { ApiProjectItemGetProjectItemsPost$Plain$Params } from '../fn/project-items/api-project-item-get-project-items-post-plain';
import { apiProjectItemProcessExcelFilePost } from '../fn/project-items/api-project-item-process-excel-file-post';
import { ApiProjectItemProcessExcelFilePost$Params } from '../fn/project-items/api-project-item-process-excel-file-post';
import { apiProjectItemProcessExcelFilePost$Plain } from '../fn/project-items/api-project-item-process-excel-file-post-plain';
import { ApiProjectItemProcessExcelFilePost$Plain$Params } from '../fn/project-items/api-project-item-process-excel-file-post-plain';
import { apiProjectItemUpdateProjectItemPatch } from '../fn/project-items/api-project-item-update-project-item-patch';
import { ApiProjectItemUpdateProjectItemPatch$Params } from '../fn/project-items/api-project-item-update-project-item-patch';
import { apiProjectItemUpdateProjectItemPatch$Plain } from '../fn/project-items/api-project-item-update-project-item-patch-plain';
import { ApiProjectItemUpdateProjectItemPatch$Plain$Params } from '../fn/project-items/api-project-item-update-project-item-patch-plain';
import { CreateProjectItemCommandResult } from '../models/create-project-item-command-result';
import { DeleteProjectitemCommandResult } from '../models/delete-projectitem-command-result';
import { GetProjectItemCostQueryResult } from '../models/get-project-item-cost-query-result';
import { GetProjectItemsCostQueryResult } from '../models/get-project-items-cost-query-result';
import { GetProjectItemsNamesQueryResult } from '../models/get-project-items-names-query-result';
import { GetProjectItemsQueryResult } from '../models/get-project-items-query-result';
import { ProcessExcelFileCommandResult } from '../models/process-excel-file-command-result';
import { UpdateProjectItemCommandResult } from '../models/update-project-item-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectItemsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectItemGetProjectItemsNamesGet()` */
  static readonly ApiProjectItemGetProjectItemsNamesGetPath = '/api/ProjectItem/GetProjectItemsNames';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemGetProjectItemsNamesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemsNamesGet$Plain$Response(params?: ApiProjectItemGetProjectItemsNamesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsNamesQueryResult>> {
    return apiProjectItemGetProjectItemsNamesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemGetProjectItemsNamesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemsNamesGet$Plain(params?: ApiProjectItemGetProjectItemsNamesGet$Plain$Params, context?: HttpContext): Observable<GetProjectItemsNamesQueryResult> {
    return this.apiProjectItemGetProjectItemsNamesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemsNamesQueryResult>): GetProjectItemsNamesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemGetProjectItemsNamesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemsNamesGet$Response(params?: ApiProjectItemGetProjectItemsNamesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsNamesQueryResult>> {
    return apiProjectItemGetProjectItemsNamesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemGetProjectItemsNamesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemsNamesGet(params?: ApiProjectItemGetProjectItemsNamesGet$Params, context?: HttpContext): Observable<GetProjectItemsNamesQueryResult> {
    return this.apiProjectItemGetProjectItemsNamesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemsNamesQueryResult>): GetProjectItemsNamesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemGetProjectItemsCostGet()` */
  static readonly ApiProjectItemGetProjectItemsCostGetPath = '/api/ProjectItem/GetProjectItemsCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemGetProjectItemsCostGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemsCostGet$Plain$Response(params: ApiProjectItemGetProjectItemsCostGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsCostQueryResult>> {
    return apiProjectItemGetProjectItemsCostGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemGetProjectItemsCostGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemsCostGet$Plain(params: ApiProjectItemGetProjectItemsCostGet$Plain$Params, context?: HttpContext): Observable<GetProjectItemsCostQueryResult> {
    return this.apiProjectItemGetProjectItemsCostGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemsCostQueryResult>): GetProjectItemsCostQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemGetProjectItemsCostGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemsCostGet$Response(params: ApiProjectItemGetProjectItemsCostGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsCostQueryResult>> {
    return apiProjectItemGetProjectItemsCostGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemGetProjectItemsCostGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemsCostGet(params: ApiProjectItemGetProjectItemsCostGet$Params, context?: HttpContext): Observable<GetProjectItemsCostQueryResult> {
    return this.apiProjectItemGetProjectItemsCostGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemsCostQueryResult>): GetProjectItemsCostQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemGetProjectItemCostGet()` */
  static readonly ApiProjectItemGetProjectItemCostGetPath = '/api/ProjectItem/GetProjectItemCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemGetProjectItemCostGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemCostGet$Plain$Response(params: ApiProjectItemGetProjectItemCostGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemCostQueryResult>> {
    return apiProjectItemGetProjectItemCostGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemGetProjectItemCostGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemCostGet$Plain(params: ApiProjectItemGetProjectItemCostGet$Plain$Params, context?: HttpContext): Observable<GetProjectItemCostQueryResult> {
    return this.apiProjectItemGetProjectItemCostGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemCostQueryResult>): GetProjectItemCostQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemGetProjectItemCostGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemCostGet$Response(params: ApiProjectItemGetProjectItemCostGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemCostQueryResult>> {
    return apiProjectItemGetProjectItemCostGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemGetProjectItemCostGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemGetProjectItemCostGet(params: ApiProjectItemGetProjectItemCostGet$Params, context?: HttpContext): Observable<GetProjectItemCostQueryResult> {
    return this.apiProjectItemGetProjectItemCostGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemCostQueryResult>): GetProjectItemCostQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemGetProjectItemsPost()` */
  static readonly ApiProjectItemGetProjectItemsPostPath = '/api/ProjectItem/GetProjectItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemGetProjectItemsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemGetProjectItemsPost$Plain$Response(params?: ApiProjectItemGetProjectItemsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsQueryResult>> {
    return apiProjectItemGetProjectItemsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemGetProjectItemsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemGetProjectItemsPost$Plain(params?: ApiProjectItemGetProjectItemsPost$Plain$Params, context?: HttpContext): Observable<GetProjectItemsQueryResult> {
    return this.apiProjectItemGetProjectItemsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemsQueryResult>): GetProjectItemsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemGetProjectItemsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemGetProjectItemsPost$Response(params?: ApiProjectItemGetProjectItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsQueryResult>> {
    return apiProjectItemGetProjectItemsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemGetProjectItemsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemGetProjectItemsPost(params?: ApiProjectItemGetProjectItemsPost$Params, context?: HttpContext): Observable<GetProjectItemsQueryResult> {
    return this.apiProjectItemGetProjectItemsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemsQueryResult>): GetProjectItemsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemCreateProjectItemPost()` */
  static readonly ApiProjectItemCreateProjectItemPostPath = '/api/ProjectItem/CreateProjectItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemCreateProjectItemPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemCreateProjectItemPost$Plain$Response(params?: ApiProjectItemCreateProjectItemPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemCommandResult>> {
    return apiProjectItemCreateProjectItemPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemCreateProjectItemPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemCreateProjectItemPost$Plain(params?: ApiProjectItemCreateProjectItemPost$Plain$Params, context?: HttpContext): Observable<CreateProjectItemCommandResult> {
    return this.apiProjectItemCreateProjectItemPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectItemCommandResult>): CreateProjectItemCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemCreateProjectItemPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemCreateProjectItemPost$Response(params?: ApiProjectItemCreateProjectItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemCommandResult>> {
    return apiProjectItemCreateProjectItemPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemCreateProjectItemPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemCreateProjectItemPost(params?: ApiProjectItemCreateProjectItemPost$Params, context?: HttpContext): Observable<CreateProjectItemCommandResult> {
    return this.apiProjectItemCreateProjectItemPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectItemCommandResult>): CreateProjectItemCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemProcessExcelFilePost()` */
  static readonly ApiProjectItemProcessExcelFilePostPath = '/api/ProjectItem/ProcessExcelFile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemProcessExcelFilePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemProcessExcelFilePost$Plain$Response(params?: ApiProjectItemProcessExcelFilePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessExcelFileCommandResult>> {
    return apiProjectItemProcessExcelFilePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemProcessExcelFilePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemProcessExcelFilePost$Plain(params?: ApiProjectItemProcessExcelFilePost$Plain$Params, context?: HttpContext): Observable<ProcessExcelFileCommandResult> {
    return this.apiProjectItemProcessExcelFilePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProcessExcelFileCommandResult>): ProcessExcelFileCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemProcessExcelFilePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemProcessExcelFilePost$Response(params?: ApiProjectItemProcessExcelFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessExcelFileCommandResult>> {
    return apiProjectItemProcessExcelFilePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemProcessExcelFilePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemProcessExcelFilePost(params?: ApiProjectItemProcessExcelFilePost$Params, context?: HttpContext): Observable<ProcessExcelFileCommandResult> {
    return this.apiProjectItemProcessExcelFilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProcessExcelFileCommandResult>): ProcessExcelFileCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemUpdateProjectItemPatch()` */
  static readonly ApiProjectItemUpdateProjectItemPatchPath = '/api/ProjectItem/UpdateProjectItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemUpdateProjectItemPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemUpdateProjectItemPatch$Plain$Response(params?: ApiProjectItemUpdateProjectItemPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemCommandResult>> {
    return apiProjectItemUpdateProjectItemPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemUpdateProjectItemPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemUpdateProjectItemPatch$Plain(params?: ApiProjectItemUpdateProjectItemPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectItemCommandResult> {
    return this.apiProjectItemUpdateProjectItemPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectItemCommandResult>): UpdateProjectItemCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemUpdateProjectItemPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemUpdateProjectItemPatch$Response(params?: ApiProjectItemUpdateProjectItemPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemCommandResult>> {
    return apiProjectItemUpdateProjectItemPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemUpdateProjectItemPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemUpdateProjectItemPatch(params?: ApiProjectItemUpdateProjectItemPatch$Params, context?: HttpContext): Observable<UpdateProjectItemCommandResult> {
    return this.apiProjectItemUpdateProjectItemPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectItemCommandResult>): UpdateProjectItemCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemDeleteProjectItemDelete()` */
  static readonly ApiProjectItemDeleteProjectItemDeletePath = '/api/ProjectItem/DeleteProjectItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemDeleteProjectItemDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemDeleteProjectItemDelete$Plain$Response(params?: ApiProjectItemDeleteProjectItemDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectitemCommandResult>> {
    return apiProjectItemDeleteProjectItemDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemDeleteProjectItemDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemDeleteProjectItemDelete$Plain(params?: ApiProjectItemDeleteProjectItemDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectitemCommandResult> {
    return this.apiProjectItemDeleteProjectItemDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectitemCommandResult>): DeleteProjectitemCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemDeleteProjectItemDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemDeleteProjectItemDelete$Response(params?: ApiProjectItemDeleteProjectItemDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectitemCommandResult>> {
    return apiProjectItemDeleteProjectItemDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemDeleteProjectItemDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemDeleteProjectItemDelete(params?: ApiProjectItemDeleteProjectItemDelete$Params, context?: HttpContext): Observable<DeleteProjectitemCommandResult> {
    return this.apiProjectItemDeleteProjectItemDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectitemCommandResult>): DeleteProjectitemCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemDownloadTemplateGet()` */
  static readonly ApiProjectItemDownloadTemplateGetPath = '/api/ProjectItem/download-template';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemDownloadTemplateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemDownloadTemplateGet$Response(params?: ApiProjectItemDownloadTemplateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiProjectItemDownloadTemplateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemDownloadTemplateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectItemDownloadTemplateGet(params?: ApiProjectItemDownloadTemplateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiProjectItemDownloadTemplateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
